import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as R from 'ramda'

import { getSurveyFromId } from 'reducers'
import SurveySettings from 'containers/Admin/Surveys/SurveySettings'

class Settings extends React.Component {
  static propTypes = {
    survey: PropTypes.object.isRequired,
  }

  static defaultProps = {
    survey: {},
  }

  render() {
    return <SurveySettings />
  }
}

const getSurveyIdFromURL = (matchProps) => {
  const {
    params: { surveyId },
  } = matchProps
  return surveyId
}

const mapState = (state, props) => {
  const surveyId = getSurveyIdFromURL(props.match)
  return {
    survey: getSurveyFromId(state, surveyId),
  }
}

export default R.compose(withRouter, connect(mapState))(Settings)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Surveys/SurveySettings.js